import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';
import {Col, GridColumnSize, Row} from '@yandex-data-ui/page-constructor';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './SearchNotFound.scss';

const b = block('search-not-found');

interface SearchNotFoundProps {
    notFoundDescription?: string;
}

const SearchNotFound: React.FC<WithTranslationProps & SearchNotFoundProps> = (props) => {
    const {i18nK, notFoundDescription} = props;
    return (
        <Row className={b()}>
            <Col
                sizes={{
                    [GridColumnSize.Lg]: 9,
                    [GridColumnSize.All]: 12,
                }}
            >
                <h4>{i18nK('search-not-found-title')}</h4>
                <HTML block={true} className={b('description')}>
                    {notFoundDescription || i18nK('search-not-found-description')}
                </HTML>
            </Col>
        </Row>
    );
};

export default withTranslation('navigation')(SearchNotFound);
